<template>
	<div class="page">
		<div class="header">
			<h2 class="title">页面预览</h2>
			<el-button type="text" @click="handleBack()" class="back-btn">返回</el-button>
		</div>
		
		<!-- Tab切换 -->
		<div class="preview-tabs">
			<el-tabs v-model="activeTab" @tab-change="handleTabChange">
				<el-tab-pane label="Web" name="web"></el-tab-pane>
				<el-tab-pane label="H5" name="h5"></el-tab-pane>
			</el-tabs>
		</div>
		
		<!-- iframe预览区域 -->
		<div class="preview-content" v-loading="loading">
			<iframe :src="currentUrl" :class="['preview-iframe', { 'preview-iframe-h5': activeTab === 'h5' }]" frameborder="0" sandbox="allow-scripts allow-same-origin" @load="onIframeLoad" @error="onIframeError"></iframe>
		</div>
	</div>
</template>
<script>
import store from '@/store/index.js';
export default {
    beforeRouteEnter: (to, from, next) => {
        store.commit("breadcrumbStore/setMenuBreadcrumb", {
            'menu': to.meta.menuBreadcrumb,
            name: '预览活动',
            path: to.fullPath
        });
        next()
    },
    data() {
        return {
            VUE_APP_WEB_URL: process.env.VUE_APP_WEB_URL,
            VUE_APP_H5_URL: process.env.VUE_APP_H5_URL,
			loading: false,
            activeTab: 'web',
            pcBannerImage: '',
            h5BannerImage: '',
            backgroundColor: '',
            rules: '',
        }
    },
    computed: {
        currentUrl() {
			console.log(this.activeTab)
			console.log(this.VUE_APP_WEB_URL)
			console.log(this.VUE_APP_H5_URL)
            const baseUrl = this.activeTab === 'web' 
                ? `${this.VUE_APP_WEB_URL}/activity` 
                : `${this.VUE_APP_H5_URL}/activity`;
            
            const params = new URLSearchParams();
            params.append('pcBannerImage', this.pcBannerImage);
            params.append('h5BannerImage', this.h5BannerImage);
            params.append('backgroundColor', this.backgroundColor);
            params.append('rules', encodeURIComponent(this.rules || ''));
            return `${baseUrl}?${params.toString()}`;
        }
    },
    created() {
        // 从路由参数获取banner和rule数据
        this.loadPreviewData()
    },
    methods: {
        onIframeLoad() {
            // iframe加载完成后执行的操作
            this.loading = false;
            console.log('iframe加载完成');
        },
		onIframeError() {
            // iframe加载失败时执行的操作
            this.loading = false;
			this.$message.error('预览加载失败！')
        },
        loadPreviewData() {
            // 从路由参数获取配置数据
			this.loading = true;
            this.pcBannerImage = this.$route.query.pcBannerImage || '';
            this.h5BannerImage = this.$route.query.h5BannerImage || '';
            this.backgroundColor = this.$route.query.backgroundColor || '#000000';
            this.rules = decodeURIComponent(this.$route.query.rules);
        },
        handleTabChange() {
            // 切换tab时自动刷新iframe
            this.loading = true;
        },
        handleBack() {
            this.$router.back();
        },
    }
}
</script>
<style scoped lang="scss">
	.page {
		background-color: #fff;
		padding: 20px;
		display: block;
		margin-top: 20px;
		border-radius: 4px;
		min-height: calc(100vh - 100px);
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
		padding-bottom: 10px;
		border-bottom: 1px solid #EBEEF5;
	}
	
	.title {
		font-size: 18px;
		font-weight: bold;
		color: #303133;
		margin: 0;
	}
	
	.back-btn {
		color: #409EFF;
		font-size: 14px;
	}

	.preview-tabs {
		margin-bottom: 15px;
	}

	.preview-content {
		height: calc(100vh - 220px);
		border: 1px solid #EBEEF5;
		border-radius: 4px;
		overflow: hidden;
	}

	.preview-iframe {
		width: 100%;
		height: 100%;
	}
	
	.preview-iframe-h5 {
		width: 750px;
		margin: 0 auto;
		display: block;
	}
	
</style>